import { Report } from "@prose-reader/shared"

export const report = Report.namespace("@oboku/archive-metadata")
